
import { useSnackbar } from 'notistack';
import React, { createContext, useContext, useState, ReactNode, useCallback } from 'react';

interface ApiWithCallbackContextType {
    callApiWithCallback: <R>(apiCall: () => Promise<R>, onSuccess: (response: R) => void, successMessage?: string, errorMessage?: string) => void;
}

const ApiWithCallbackContext = createContext<ApiWithCallbackContextType | undefined>(undefined);
export const ApiWithCallbackProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const { enqueueSnackbar } = useSnackbar();
    const callApiWithCallback = useCallback(async <R,>(apiCall: () => Promise<R>, onSuccess: (response: R) => void, successMessage?: string, errorMessage?: string) => {
        try {
            const response = await apiCall();
            onSuccess(response);
            if (successMessage !== '')
                enqueueSnackbar(successMessage ?? 'Operation completed successfully!', { variant: 'success' });
            // toast.success('Operation completed successfully!');
        } catch (error) {
            console.error('API call failed', error);
            enqueueSnackbar(errorMessage ?? 'Operation failed. Please try again.' + error, { variant: 'error' });
            // toast.error('Operation failed. Please try again.');
        }
    }, [enqueueSnackbar]);
    // const valueCallback = { callApiWithCallback };
    const memoizedValueCallback = React.useMemo(() => { return { callApiWithCallback } }, [callApiWithCallback]);

    return (
        <ApiWithCallbackContext.Provider value={memoizedValueCallback}>
            {children}
        </ApiWithCallbackContext.Provider>
    );
};
export const useApiWithCallback = () => {
    const context = useContext(ApiWithCallbackContext);
    if (context === undefined) {
        throw new Error('useApi must be used within an ApiProvider');
    }
    return context;
};